import comp from '../components/barrel';
import ADs_Heirs from './ADs_Heirs';
import listReturnState from '../js/listReturnState';

export default {
  tabsYN: 1,
  application_uuid: null,
  async prepare() {
    this.application_uuid = this.vars?.application_uuid || thsPage?.vars?.application_uuid;
  },
  async render() {
    const rec = this.recipe.methods;

    let data = {};
    if (rec.length) {
      data = await O.PREP(rec);
    }
    await this.loadPage(data);
  },
  async loadPage(data) {
    const back = listReturnState.take('ViewApplication');
    const activeTab =
      (await comp.sideNav(this.tabs)) ||
      this.tabs?.find?.((t) => t.html_text === 'VAt_Overview')?.html_text ||
      'VAt_Overview';
    listReturnState.prependBackToSideNav('Back to applications', back);
    await O.changeTab(activeTab, {
      application_uuid: this.application_uuid || this.vars?.application_uuid,
    });
  },

  async pageProgress(pageData, nextPrev) {
    //thsPage.pageProgress()
    // Eg. pageProgress: ------------
    // commenced: true;
    // complete: true;
    // html_text: 'ADs_Marriage';
    // next_page: 'ADs_ChildrenDetails';
    // prev_page: 'ADs_PersonalDetails';
    // short_text: 'Marriage Details';

    if (nextPrev) {
      await this.changeSideNavTab(pageData[`${nextPrev}`] || nextPrev);
    }

    const el = pageData?.html_text ? U.id(pageData.html_text) : null;
    if (el?.firstChild) {
      const spanCircle = el.firstChild;
      spanCircle.className = '';
      // Set colours
      if (pageData.complete) {
        spanCircle.classList.add('complete');
      } else if (pageData.commenced) {
        spanCircle.classList.add('incomplete');
      }
    }
  },
  async changeSideNavTab(pageID) {
    await O.changeSubTab(pageID);
    //Cheat to page --
    // await O.changeSubTab('ADs_Equity');
    window.scrollTo({top: 0});

    // Sub-sub tabs removed - no longer needed
  },
  async goToMainTab(shortText, fallbackId = '') {
    const tabs = this.tabs || {};
    const tabList = Array.isArray(tabs) ? tabs : Object.values(tabs);
    let tabId;
    if (shortText && shortText.toLowerCase() === 'will draft') {
      tabId = this.getWillDraftTabId();
    } else {
      const match = tabList.find(
        (tab) => tab.short_text && tab.short_text.toLowerCase() === shortText.toLowerCase()
      );
      tabId = match?.html_text || fallbackId;
    }
    if (!tabId) {
      return;
    }
    await O.changeTab(tabId);
    window.scrollTo({top: 0});
  },
  getWillDraftTabId() {
    const tabs = this.tabs || {};
    const tabList = Array.isArray(tabs) ? tabs : Object.values(tabs);
    const advisorTab = tabList.find((tab) => tab.html_text === 'VAt_Will_advisor');
    if (advisorTab) {
      return 'VAt_Will_advisor';
    }
    const willTab = tabList.find((tab) => tab.html_text === 'VAt_Will');
    return willTab?.html_text || 'VAt_Will';
  },
};
